import { render, staticRenderFns } from "./ControlePedidosFiltros.vue?vue&type=template&id=af61c428"
import script from "./ControlePedidosFiltros.vue?vue&type=script&lang=js"
export * from "./ControlePedidosFiltros.vue?vue&type=script&lang=js"
import style0 from "./ControlePedidosFiltros.vue?vue&type=style&index=0&id=af61c428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports